'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDeviceTablet = function TiDeviceTablet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 6.7h-15c-0.9 0-1.6 0.7-1.6 1.6v20c0 1 0.7 1.7 1.6 1.7h5.9c0 0.9 0.7 1.7 1.6 1.7s1.7-0.8 1.7-1.7h5.8c1 0 1.7-0.7 1.7-1.7v-20c0-0.9-0.7-1.6-1.7-1.6z m0 21.6h-15v-20h15v20z m1.7-26.6h-18.3c-2.8 0-5 2.2-5 5v25c0 2.7 2.2 5 5 5h18.3c2.8 0 5-2.3 5-5v-25c0-2.8-2.2-5-5-5z m1.7 30c0 0.9-0.8 1.6-1.7 1.6h-18.3c-1 0-1.7-0.7-1.7-1.6v-25c0-0.9 0.7-1.7 1.7-1.7h18.3c0.9 0 1.7 0.7 1.7 1.7v25z' })
        )
    );
};

exports.default = TiDeviceTablet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/device-tablet.js
// module id = 3810
// module chunks = 0